const getAddress = (address)=>{
    if (!address) {
        return undefined;
    }
    const { apartment , city , countryCode , firstName , lastName , streetName , streetNumber , additionalStreetInfo , postalCode , region ,  } = address;
    return {
        city,
        countryCode,
        firstName,
        lastName,
        streetName,
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : '',
        apartment: apartment !== null && apartment !== void 0 ? apartment : '',
        postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : '',
        additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : '',
        region: region !== null && region !== void 0 ? region : ''
    };
};

export { getAddress };
//# sourceMappingURL=get-address.js.map
